import React from 'react';
import { Box, Hidden } from '@material-ui/core';
import TitleText from './TitleText';
import BodyText from './BodyText';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
const SkeletonFilter = () => {
	return (
		<>
    
			{[0,1,2,3].map((i)=>{

return <Box
display='flex'
style={{
    padding: 15,
                        boxShadow: '0 3px 30px 0 rgb(0 0 0 / 10%)',
                        background: 'white',
                        borderRadius: 5,
}}
// justifyContent='space-between'
mt={'10px'}
// alignItems='center'
>
{/* <Box display='flex' alignItems='center'>

    <img src='https://www.myholidays.com/en-us/ibe/static/media/loadmore.27948dee.gif' style={{height:'150px'}}/>
</Box> */}

<Box style={{width:'100%'}}>
    <Skeleton variant='text' width='50%' style={{borderRadius:10}}  />
    <Skeleton variant='text' width='60%' style={{borderRadius:10}} />
    <Skeleton variant='text' width='50%' style={{borderRadius:10}} />
    <Skeleton variant='text' width='40%' style={{borderRadius:10}} />
    {/* <Skeleton variant='text' width='5%'  /> */}

    {/* <Skeleton variant='text' width='60px' /> */}
</Box>
{/* <Hidden only={['xs']}>
    <Box alignItems='center' textAlign='center'>
        <Skeleton variant='text' width='100px' />

        <Skeleton variant='text' width='60px' />
    </Box>
    <Box>
        <Skeleton variant='text' width='60px' />

        <Skeleton variant='text' width='60px' />
    </Box>
</Hidden>
<Hidden only={['xs']}>
<Box alignItems='center' display='flex'>
    <Skeleton variant='text' width='60px' height='30px' />
    <Box style={{ marginLeft: 10 }}></Box>
    <Skeleton variant='text' width='60px' height='60px' />
    <Skeleton variant='text' width='60px' height='60px' />
</Box>
</Hidden> */}
</Box>
            })}
		</>
	);
};

export default SkeletonFilter;
